import {Component, computed, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TooltipModule} from 'primeng/tooltip';
import {ButtonModule} from 'primeng/button';

export enum CardLevel {
  First = 'first',
  Second = 'second',
  Third = 'third',
}

export enum ButtonSeverity {
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Info = 'info',
  Warn = 'warn',
  Help = 'help',
  Danger = 'danger',
}

type ButtonIconPosition = 'left' | 'right' | 'top' | 'bottom';

const CARD_LEVEL_ORDER: CardLevel[] = [CardLevel.First, CardLevel.Second, CardLevel.Third];

@Component({
  selector: 'app-generic-button-card',
  imports: [CommonModule, TooltipModule, ButtonModule],
  templateUrl: './generic-button-card.component.html',
})
export class GenericButtonCardComponent {
  readonly title = input('');
  readonly testId = input<string>();
  readonly styleClass = input('');
  readonly actionLabel = input<string>();
  readonly actionDisabled = input(false);
  readonly actionStyleClass = input('w-full text-sm! tracking-wider uppercase');
  readonly actionIcon = input<string>();
  readonly actionIconPos = input<ButtonIconPosition>('right');
  readonly onAction = input<() => void>();
  readonly cardLevel = input<CardLevel>(CardLevel.First);
  readonly buttonSeverity = input<ButtonSeverity>();

  protected readonly buttonLevel = computed(() => {
    const idx = CARD_LEVEL_ORDER.indexOf(this.cardLevel());
    const nextIdx = Math.min(idx + 1, CARD_LEVEL_ORDER.length - 1);
    return CARD_LEVEL_ORDER[nextIdx];
  });

  protected readonly cardLevelClass = computed(() => `level-${this.cardLevel()}`);

  protected readonly buttonClasses = computed(() => {
    return this.buttonSeverity()
      ? `${this.actionStyleClass()}`
      : `${this.actionStyleClass()} p-button-text level-${this.buttonLevel()}`;
  });

  protected readonly showActionIconLeft = computed<boolean>(
    () => !!this.actionIcon() && this.actionIconPos() === 'left',
  );

  protected readonly showActionIconRight = computed<boolean>(
    () => !!this.actionIcon() && this.actionIconPos() === 'right',
  );
}
